import axios from 'axios';
import { TokenLogout } from 'API/Logout/logout';

const url = process.env.REACT_APP_POST_APPROVAL_URL;
const apiurl = process.env.REACT_APP_BANKVERIFY_URL;

// Csp Coding Creation
export const CspCodeCreateApi = async (Data, StateData, UserData, handleClick, setSuccess, handleError, setErrorRes, setIsLoading) => {
  setIsLoading(true);
  console.log('enter csp');
  const formdata = new FormData();
  formdata.append('agent_code', StateData.code);
  formdata.append('agent_name', StateData.name);
  formdata.append('bank_name', StateData.bank);
  formdata.append('csp_code', Data.csp_code ? Data.csp_code : UserData && UserData[0].csp_code);
  formdata.append('csp_type', Data.csp_type ? Data.csp_type : UserData && UserData[0].csp_type);
  // formdata.append('csp_status', Data.csp_status);
  formdata.append('csp_code_creation_date', Data.csp_code_creation_date);
  formdata.append('_id', StateData.id);
  formdata.append('user_id', StateData.userId);
  // formdata.append('product_id', StateData.productId);

  try {
    await axios
      .post(`${url}/csp/csp/code/add`, formdata, {
        headers: {
                  Authorization:`Bearer ${sessionStorage.getItem('token')}`
        }
      })
      .then((res) => {
        console.log('res', res);
        if (res.status === 201) {
          handleClick();
          setIsLoading(false);
          setSuccess(res.data.message);
        }
      })
      .catch((error) => {
        TokenLogout(error);
        console.log('error', error);
        handleError();
        setIsLoading(false);
        setErrorRes(error.response.data.error);
      });
  } catch (error) {
    TokenLogout(error);
    console.log('error', error);
    handleError();
    setIsLoading(false);
    setErrorRes('somthing went Wrong');
  }
};

export const CspCodeActivateApi = async (
  Data,
  Upload,
  StateData,
  handleClick,
  NameBank,
  setSuccess,
  handleError,
  setErrorRes,
  setIsLoadingAct
) => {
  setIsLoadingAct(true);
  console.log('enter csp');
  const formdata = new FormData();
  formdata.append('csp_code', StateData.cspcode);
  // formdata.append('vtc_code', Data.vtc_code);
  formdata.append('od_account_name', NameBank);
  formdata.append('od_account_number', Data.od_account_number);
  formdata.append('od_ifsc_code', Data.od_ifsc_code);
  formdata.append('activation_remarks', Data.activation_remarks);
  formdata.append('csp_code_activation_date', Data.csp_code_activation_date);
  formdata.append('first_transaction_document', Upload);
  formdata.append('_id', StateData.finvestausersproductid);

  try {
    await axios
      .post(`${url}/csp/csp/code/active`, formdata, {
        headers: {
                  Authorization:`Bearer ${sessionStorage.getItem('token')}`
        }
      })
      .then((res) => {
        console.log('res', res);
        if (res.status === 201) {
          handleClick();
          setIsLoadingAct(false);
          setSuccess(res.data.message);
          setTimeout(() => {
            window.location.href = '/Admin/Terminal_mapping';
          }, 2000);
        }
      })
      .catch((error) => {
        TokenLogout(error);
        console.log('error', error);
        handleError();
        setIsLoadingAct(false);
        setErrorRes(error.response ? error.response.data.error : 'somthing went Wrong');
      });
  } catch (error) {
    TokenLogout(error);
    handleError();
    setIsLoadingAct(false);
    setErrorRes(error.response ? error.response.data.error : 'somthing went Wrong');
  }
};

export const CspCodeActivateApiView = async (bankname, code, name, page, limit, setIsLoading, setResData, setTotalCount) => {
  setIsLoading(true);
  try {
    await axios
      .post(
        `${url}/csp/kiosk/approved/list?page=${page}&limit=${limit}`,
        {
         ...(bankname&&{ bank_name: bankname}),
          ...(code&&{agent_code: code}),
          ...(name&&{agent_name: name})
        },
        {
          headers: {
                    Authorization:`Bearer ${sessionStorage.getItem('token')}`
          }
        }
      )
      .then((res) => {
        console.log('res', res);
        if (res.status === 200) {
          setIsLoading(false);
          setResData(res.data.all_approved_data);
          setTotalCount(res.data.total_count);
        }
      })
      .catch((error) => {
        TokenLogout(error);
        console.log('error', error);
        setIsLoading(false);
      });
  } catch (error) {
    TokenLogout(error);
    setIsLoading(false);
    console.log('error', error);
  }
};

export const CspCodeActivateApiPut = async (Data, StateData, handleClick, setSuccess, handleError, setErrorRes, setIsLoadingEdit) => {
  setIsLoadingEdit(true);
  console.log('Dta', Data);
  const formdata = new FormData();
  formdata.append('agent_code', StateData.code);
  formdata.append('agent_name', StateData.name);
  formdata.append('bank_name', StateData.bank);
  formdata.append('csp_code', StateData.cspcode);
  formdata.append('csp_type', Data.csp_type ? Data.csp_type : StateData.csptype);
  // formdata.append('csp_status', Data.csp_status?Data.csp_status:StateData.cspstatus);
  formdata.append('csp_code_creation_date', Data.csp_code_creation_date ? Data.csp_code_creation_date : StateData.codecreatedate);
  // formdata.append('finvesta_users_product_id', Data.id);
  formdata.append('_id', StateData.id);
  // formdata.append('product_id', Data.productId);
  try {
    await axios
      .put(`${url}/csp/csp/create/edit`, formdata, {
        headers: {
                  Authorization:`Bearer ${sessionStorage.getItem('token')}`
        }
      })
      .then((res) => {
        handleClick();
        setIsLoadingEdit(false);
        setSuccess(res.data.message);
      })
      .catch((error) => {
        TokenLogout(error);
        handleError();
        setIsLoadingEdit(false);
        setErrorRes(error.response.data.error);
      });
  } catch (error) {
    TokenLogout(error);
    handleError();
    setIsLoadingEdit(false);
    setErrorRes(error.response ? error.response.data.error : 'somthing went Wrong');
  }
};

export const CspCodeActivateApiDelete = async (id, code, handleclick, setSuccess, handleErr, setErr) => {
  const formdata = new FormData();
  formdata.append('_id', id);
  formdata.append('csp_code', code);
  try {
    await axios
      .delete(`${url}/csp/csp/code/delete`, {
        headers: {
                  Authorization:`Bearer ${sessionStorage.getItem('token')}`
        },
        data: formdata
      })
      .then((res) => {
        console.log('res', res);
        if (res.status === 200) {
          handleclick();
          setSuccess(res.data.message);
        }
      });
  } catch (error) {
    TokenLogout(error);
    handleErr();
    setErr(error.response ? error.response.data.error : 'somthing went wrong');
  }
};

export const CspCodeActivateApiList = async (bankname, code, name, page, limit, setIsLoading, setListData, setTotalCount) => {
  setIsLoading(true);
  try {
    await axios
      .post(
        `${url}/csp/csp/code/list?page=${page}&limit=${limit}`,
        {
         ...(bankname&&{ bank_name: bankname}),
          ...(code&&{agent_code: code}),
          ...(name&&{agent_name: name})
        },
        {
          headers: {
                    Authorization:`Bearer ${sessionStorage.getItem('token')}`
          }
        }
      )
      .then((res) => {
        console.log('res', res);
        if (res.status === 200) {
          setIsLoading(false);
          setListData(res.data.all_csp_data);
          setTotalCount(res.data.total_count);
        }
      })
      .catch((error) => {
        TokenLogout(error);
        setIsLoading(false);
        console.log('error', error);
      });
  } catch (error) {
    TokenLogout(error);
    setIsLoading(false);
    console.log('error', error);
  }
};

// Leegality

export const LeegalityAgreementApi = async (
  UserId,
  productId,
  cspCode,
  setClickAgreement,
  setErrAgreement,
  setIsloading,
  handleReFetch
) => {
  setIsloading(true);
  const formdata = new FormData();
  formdata.append('user_id', UserId);
  formdata.append('product_id', productId);
  // formdata.append('csp_id', cspId);
  formdata.append('csp_code', cspCode);

  try {
    await axios
      .post(`${url}/csp/code/agreement/link`, formdata, {
        headers: {
                  Authorization:`Bearer ${sessionStorage.getItem('token')}`
        }
      })
      .then((res) => {
        if (res.status === 200) {
          console.log('hjggdsertgjghg', res);
          // setClickAgreement(res.data.data?res.data.data.invitations[0].message:res.data.message);
          setClickAgreement(res.data.message);
          setIsloading(false);
          setTimeout(() => {
            handleReFetch();
          }, 4000);
          // handleReFetch()
        }
      })
      .catch((error) => {
        TokenLogout(error);
        setErrAgreement(error.response ? error.response.data.error : 'Something went wrong');
        setIsloading(false);
        setTimeout(() => {
          handleReFetch();
        }, 4000);
      });
  } catch (error) {
    TokenLogout(error);
    setErrAgreement(error.response ? error.response.data.error : 'Something went wrong');
    setIsloading(false);
    setTimeout(() => {
      handleReFetch();
    }, 4000);
  }
};

// export const StatusCheck = async (setCheckStatus)=>{
//   const docid = sessionStorage.getItem('documentID')
//   try {
//     await axios.post(`${url}/csp/status_check`,{},{
//       params:{
//         documentID:docid
//       }
//     },{
//       headers:{
//                 Authorization:`Bearer ${sessionStorage.getItem('token')}`
//       }
//     }) .then((res)=>{
//       console.log("res",res);
//       if(res.data[0].sign_status && res.data[1].sign_status){
//         sessionStorage.setItem('Eagreement', true)
//       }
//       else{
//         setCheckStatus(true)
//       }
//     })
//   }
//   catch (error){
// TokenLogout(error)
//   console.log("error",error);

//   }
// }

// Terminal mapping

export const TerminalMappingApi = async (setIsLoading,Data, StateData, setSuccess, setErrorRes) => {
  setIsLoading(true)
  const formdata = new FormData();
  formdata.append('csp_code', StateData.code);
  formdata.append('terminal_id', Data.terminal_id);
  formdata.append('connectivity_type', Data.connectivity_type);
  formdata.append('terminal_mapping_date', Data.mapping_date);
  formdata.append('finger_print_capture_date', Data.fingerprint_capture_date);
  try {
    await axios
      .post(`${url}/csp/terminal/mapping/add`, formdata, {
        headers: {
                  Authorization:`Bearer ${sessionStorage.getItem('token')}`
        }
      })
      .then((res) => {
        if (res.status === 201) {
          setIsLoading(false)
          setSuccess(res.data.message);
          window.location.href = '/Admin/Terminal_mapping';
        }
      })
      .catch((error) => {
        setIsLoading(false)
        TokenLogout(error);
        // handleError();
        setErrorRes(error.response ? error.response.data.error : 'Something went wrong');
      });
  } catch (error) {
    setIsLoading(false)
    TokenLogout(error);
    // handleError();
    setErrorRes(error.response ? error.response.data.error : 'Something went wrong');
  }
};

// list of terminal list

export const TerminalMappingApiViewList = async (setIsLoading,bankname, code, name, page, limit, setTryData, setTotalCountTer) => {
  setIsLoading(true)
  try {
    await axios
      .post(
        `${url}/csp/terminal/mapped/list?page=${page}&limit=${limit}`,
        {
         ...(bankname&&{ bank_name: bankname}),
          ...(code&&{agent_code: code}),
          ...(name&&{agent_name: name})
        },
        {
          headers: {
                    Authorization:`Bearer ${sessionStorage.getItem('token')}`
          }
        }
      )
      .then((res) => {
        console.log('res', res);
        if (res.status === 200) {
          setIsLoading(false)
          setTryData(res.data.terminal_data);
          setTotalCountTer(res.data.total_count);
        }
      });
  } catch (error) {
    TokenLogout(error);
    console.log('error', error);
    setIsLoading(false)
  }
};

export const TerminalMappingApiView = async (setIsLoading,bankname, code, name, page, limit, setResData, setTotalCount) => {
  setIsLoading(true)
  try {
    await axios
      .post(
        `${url}/csp/csp/actived/list?page=${page}&limit=${limit}`,
        {
          ...(bankname&&{ bank_name: bankname}),
          ...(code&&{agent_code: code}),
          ...(name&&{agent_name: name})
        },
        {
          headers: {
                    Authorization:`Bearer ${sessionStorage.getItem('token')}`
          }
        }
      )
      .then((res) => {
        if (res.status === 200) {
          setIsLoading(false)
          setResData(res.data.all_csp_data);
          setTotalCount(res.data.total_count);
        }
      });
  } catch (error) {
    setIsLoading(false)
    TokenLogout(error);
    console.log('error', error);
  }
};

export const TerminalMappingApiEdit = async (setIsLoading,StateData, Data, handleError, handleClick, setSuccess, setErrorRes) => {
  setIsLoading(true)
  const formdata = new FormData();
  formdata.append('_id', StateData.id);
  // formdata.append('csp_code', StateData.code?StateData.code:Data.terminal_id);
  // formdata.append('terminal_id', Data.terminal_id?Data.terminal_id:StateData.terminal_id);
  formdata.append('connectivity_type', Data.connectivity_type ? Data.connectivity_type : StateData.type);
  formdata.append('terminal_mapping_date', Data.mapping_date ? Data.mapping_date : StateData.map_date);
  formdata.append('finger_print_capture_date', Data.fingerprint_capture_date ? Data.fingerprint_capture_date : StateData.fingerprint_date);
  try {
    await axios
      .put(`${url}/csp/terminal/mapped/edit`, formdata, {
        headers: {
                  Authorization:`Bearer ${sessionStorage.getItem('token')}`
        }
      })
      .then((res) => {
        if (res.status === 200) {
          setIsLoading(false)
          handleClick();
          setSuccess(res.data.message);
        }
      })
      .catch((error) => {
        setIsLoading(false)
        TokenLogout(error);
        handleError();
        setErrorRes(error.response ? error.response.data.error : 'something went wrong');
      });
  } catch (error) {
    setIsLoading(false)
    TokenLogout(error);
    // console.log('error', error);
    handleError();
    setErrorRes(error.response ? error.response.data.error : 'something went wrong');
  }
};

export const TerminalMappingApiDelete = async (id, code, handleclick, setSuccess, handleErr, setErr) => {
  const formdata = new FormData();
  formdata.append('_id', id);
  formdata.append('terminal_id', code);
  try {
    await axios
      .delete(`${url}/csp/terminal/mapped/delete`, {
        headers: {
                  Authorization:`Bearer ${sessionStorage.getItem('token')}`
        },
        data: formdata
      })
      .then((res) => {
        console.log('res', res);
        if (res.status === 200) {
          handleclick();
          setSuccess(res.data.message);
        }
      });
  } catch (error) {
    TokenLogout(error);
    console.log('error', error);
    handleErr();
    setErr('somthing went wrong');
  }
};

export const PaymentReportapi = async (PaymentData, setDataView, setDataError) => {
  console.log('UserData', PaymentData);

  try {
    await axios
      .post(
        `${apiurl}/ccavenue/agent/payment/report`,
        {
          agent_name: PaymentData.aadhaar_name,
          agent_mobile: PaymentData.mobile_number,
          agent_email: PaymentData.email_address
        },
        {
          headers: {
                    Authorization:`Bearer ${sessionStorage.getItem('token')}`
          }
        }
      )
      .then((res) => {
        if (res.status === 200) {
          setDataView(res.data);
        }
      })
      .catch((error) => {
        TokenLogout(error);
        setDataError(error.response.data.error);
      });
  } catch (error) {
    TokenLogout(error);
    setDataError(error.response.data.error);
  }
};

export const LeegalityCheckStatusapi = async (
  setIsloading,
  id,
  code,
  setleegSuccess,
  handleLeegalitySucess,
  setLeegalityErr,
  handleReFetch
) => {
  setIsloading(true);
  const formdata = new FormData();
  formdata.append('_id', id);
  formdata.append('csp_code', code);
  try {
    await axios
      .post(`${url}/csp/code/agreement/check`, formdata, {
        headers: {
                  Authorization:`Bearer ${sessionStorage.getItem('token')}`
        }
      })
      .then((res) => {
        if (res.status === 200) {
          handleLeegalitySucess();
          setleegSuccess(res.data.status);
          setIsloading(true);
          setTimeout(() => {
            handleReFetch();
          }, 4000);
        }
      })
      .catch((error) => {
        TokenLogout(error);
        setLeegalityErr(error.response ? error.response.data.error : 'Something went wrong');
        // setLeegalityErr(error.response?error.response.data.agent_data:null)
        setIsloading(false);
        setTimeout(() => {
          handleReFetch();
        }, 4000);
      });
  } catch (error) {
    TokenLogout(error);
    setLeegalityErr(error.response ? error.response.data.error : 'Something went wrong');
    setLeegalityErr(error.response ? error.response.data.agent_data : null);
    setIsloading(false);
    setTimeout(() => {
      handleReFetch();
    }, 4000);
  }
};

export const OdBankList = async (prodID, setBankList) => {
  try {
    await axios
      .post(
        `${apiurl}finvesta-user/fi_banks`,
        { product_id: prodID },
        {
          headers: {
                    Authorization:`Bearer ${sessionStorage.getItem('token')}`
          }
        }
      )
      .then((res) => {
        if (res.status === 200) {
          setBankList(res.data);
        }
      })
      .catch((error) => {
        TokenLogout(error);
        console.log('Error', error.response.data.error);

        // setBankListError(error.response?error.response.data.error:'Something went wrong')
      });
  } catch (error) {
    TokenLogout(error);
    console.log('Error', error.response.data.error);
    // setBankListError(error.response?error.response.data.error:'Something went wrong')
  }
};
